import { render } from "./PageMenu.vue?vue&type=template&id=650b47ac&ts=true&lang=html"
import script from "./PageMenu.vue?vue&type=script&lang=ts"
export * from "./PageMenu.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__